import {createFieldValidator, injectMessage} from '@lib/validation/validators';

export const required = createFieldValidator(
  (val: any) => !(val === '' || val === null || val === undefined),
  'この項目は必須です',
);

export const format = (regexp: RegExp) =>
  createFieldValidator((val: any) => {
    return regexp.test(val.toString());
  }, 'TODO');

export const equal = (value: any) =>
  createFieldValidator((val: any) => {
    return val === value;
  }, 'TODO');

/* eslint-disable no-control-regex */
const EMAIL_REGEX =
  /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
/* eslint-enable no-control-regex */

export const emailFormat = injectMessage(
  'メールアドレスを正しく入力してください',
)(format(EMAIL_REGEX));

export const truthy = injectMessage('この項目は必須項目です')(equal(true));

export const falsy = injectMessage('この項目は必須項目です')(equal(false));
